import React, { useState, useRef } from 'react';
import { TextField, Popover, ToggleButton, ToggleButtonGroup, InputAdornment } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const hours = [
  '07:00',
  '08:00',
  '09:00',
  '10:00',
  '11:00',
  '12:00',
  '13:00',
  '14:00',
  '15:00',
  '16:00',
  '17:00',
  '18:00',
  '19:00',
  '20:00',
  '21:00',
];

export default function TimePickerGridSelect({ label, value, onChange, disabledHours = [] }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const inputRef = useRef(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (event, newValue) => {
    if (newValue !== null) {
      onChange(newValue);
      handleClose();
    }
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <TextField
        fullWidth
        label={label}
        value={value}
        onClick={handleOpen}
        inputRef={inputRef}
        InputLabelProps={{
          shrink: true,
          sx: {
            paddingTop: '18px',
            paddingLeft: '44px',
            color: '#F985C4',
            fontWeight: 600,
          },
        }}
        InputProps={{
          notched: false,
          readOnly: true,
          startAdornment: (
            <InputAdornment position="start">
              <AccessTimeIcon sx={{ color: '#3e5695' }} />
            </InputAdornment>
          ),
          sx: {
            backgroundColor: '#ffffff',
            fontSize: '12px',
            fontWeight: '600',
            color: '#3e5695',
            borderRadius: '12px',
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#8f8c8e',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#8f8c8e',
            },
            '& input': {
              cursor: 'pointer',
            },
            '& .MuiOutlinedInput-input': {
              paddingRight: '32px',
              paddingTop: '26px',
              paddingBottom: '8px',
            },
          },
        }}
      />

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        PaperProps={{
          sx: {
            mt: 1,
            p: 2,
            borderRadius: '12px',
            boxShadow: 3,
          },
        }}
      >
        <ToggleButtonGroup
          value={value}
          exclusive
          onChange={handleSelect}
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: 1,
          }}
        >
          {hours.map((hour) => {
            const isDisabled = disabledHours.includes(hour);
            const isSelected = value === hour;
            return (
              <ToggleButton
                key={hour}
                value={hour}
                disabled={disabledHours.includes(hour)}
                sx={{
                  borderRadius: '12px !important',
                  textTransform: 'none',
                  fontWeight: 600,
                  fontSize: '12px',
                  py: '4px',
                  px: '8px',
                  minHeight: 'unset',
                  border: isSelected
                    ? '2px solid #3e5695 !important'
                    : !isDisabled
                    ? '1px solid #3e5695 !important'
                    : '1px solid #eee !important',
                  backgroundColor: isSelected
                    ? '#3e5695 !important'
                    : isDisabled
                    ? '#eee'
                    : '#ffffff',
                  color: isSelected ? '#ffffff !important' : isDisabled ? '#aaa' : '#3e5695',
                }}
              >
                {hour}
              </ToggleButton>
            );
          })}
        </ToggleButtonGroup>
      </Popover>
    </>
  );
}
